document.addEventListener("DOMContentLoaded", function() {
  var daysAfterToday = 2;
  var today = new Date();
  var shipDate = new Date(today.setDate(today.getDate() + daysAfterToday));
  var options = { weekday: 'short', month: 'long', day: 'numeric' };
  var formattedDate = shipDate.toLocaleDateString(document.documentElement.lang || 'en-US', options);
  document.getElementById('shipping-date').textContent = formattedDate;
});
